module.exports = __webpack_public_path__ + "img/screen2.ee60c1bc.jpg";